import { Component, Inject, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatActionList, MatDivider, MatListItem } from '@angular/material/list';
import { MatExpansionPanelActionRow } from '@angular/material/expansion';
import { PackageService } from '../../../data/package.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    switchMap,
    tap,
    finalize,
    catchError,
    withLatestFrom,
    startWith
} from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IconComponent } from '../../shared/icon/icon.component';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Package } from '../../../models/package';
import { emptyPage } from '../../../constants/empty-page';
import { selectShipmentEditorPackagingType } from '../../../store/shipment-editor/shipment-editor.state';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { PackagingTypeName } from '../../../utils/packaging-type-name';
import {
    shipmentEditorAddEmptyPackage,
    shipmentEditorAddPackageFromTemplate
} from '../../../store/shipment-editor/shipment-editor.actions';

@Component({
    selector: 'app-package-select',
    imports: [
    MatFormField,
    MatLabel,
    MatInput,
    MatActionList,
    MatHint,
    MatDivider,
    MatSuffix,
    ReactiveFormsModule,
    MatListItem,
    AsyncPipe,
    IconComponent
],
    templateUrl: './package-select.component.html',
    styleUrl: './package-select.component.scss'
})
export class PackageSelectComponent {

    public searchControl = new FormControl('');
    public searchActive$ = new BehaviorSubject<boolean>(true);

    constructor(private dialogRef: MatDialogRef<PackageSelectComponent>, private snackBar: MatSnackBar,
                private packageService: PackageService, private store: Store<AppState>) {
    }

    public packagingType$ = this.store.select(selectShipmentEditorPackagingType);
    public packagingTypeDisplay$ = this.packagingType$.pipe(
        map(packagingType => PackagingTypeName.describe(packagingType))
    );

    public filteredPackages$: Observable<Package[]> = this.searchControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(term => term.length > 2),
        startWith(''),
        withLatestFrom(this.packagingType$),
        map(([ term, packagingType ]) => ({ packagingType, itemsPerPage: 10, description: term })),
        tap(() => this.searchActive$.next(true)),
        switchMap(query => this.packageService.query(query).pipe(
            finalize(() => this.searchActive$.next(false)),
            catchError(error => {
                this.snackBar.open($localize`Error searching.  Please try again.`);
                console.error(error);
                return of(emptyPage);
            })
        )),
        map(response => response.page),
    );

    selectPackage(template: Package): void {
        this.store.dispatch(shipmentEditorAddPackageFromTemplate({ template }));
        this.dialogRef.close();
    }

    newPackage(): void {
        this.store.dispatch(shipmentEditorAddEmptyPackage());
        this.dialogRef.close();
    }
}

